export default "__VITE_ASSET__6mTmy2jf__"